import type { TFunction } from "i18next";
import {
  CheckOutlined,
  PlusOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import type { FooterBarItem } from "./footerPinning";

interface MainFooterButtonsOptions {
  t: TFunction;
  canOpenBill: boolean;
  canCloseBill: boolean;
  hasSelectedBill: boolean;
  /** Закрита без бон или в процес на закриване — без „Добави". */
  isActionDisabled: boolean;
  isSelectedBillClosing: boolean;
  /** Режим „Схема" без избрана маса за отваряне (свободна или със сметка в закриване). */
  newTableDisabled: boolean;
  onNewTable?: () => void;
  onAddToTable?: () => void;
  onClose: () => void;
  /** „Закрий" е заключено (локален режим + отстъпка в € на сметката). */
  closeLockedTooltip?: string;
}

/**
 * Основните бутони на лентата под масите в обичайния им ред: Нова маса (F5) ·
 * Добави (F6) · Закрий (F7) — само тези с право. Ключовете им
 * (`MAIN_FOOTER_KEYS`) са в личната подредба на лентата — не ги преименувай.
 * Изваден от `TableFooter`.
 */
export const mainFooterButtons = ({
  t,
  canOpenBill,
  canCloseBill,
  hasSelectedBill,
  isActionDisabled,
  isSelectedBillClosing,
  newTableDisabled,
  onNewTable,
  onAddToTable,
  onClose,
  closeLockedTooltip,
}: MainFooterButtonsOptions): FooterBarItem[] =>
  [
    canOpenBill && {
      key: "newTable",
      button: {
        icon: <PlusOutlined />,
        label: t("ordering.newTable"),
        onClick: onNewTable,
        disabled: newTableDisabled,
        shortcut: "F5",
      },
    },
    canOpenBill && {
      key: "addToTable",
      button: {
        icon: <ShoppingCartOutlined />,
        label: t("ordering.add"),
        onClick: onAddToTable,
        disabled: !hasSelectedBill || isActionDisabled,
        variant: "primary",
        shortcut: "F6",
      },
    },
    canCloseBill && {
      key: "closeTable",
      button: {
        icon: <CheckOutlined />,
        label: t("ordering.closeTable"),
        onClick: onClose,
        disabled: !hasSelectedBill || isSelectedBillClosing,
        lockedTooltip: closeLockedTooltip,
        variant: "danger",
        shortcut: "F7",
        loading: isSelectedBillClosing,
      },
    },
  ].filter(Boolean) as FooterBarItem[];
